<template>
<!-- 增加标签对话框 -->
<!-- 注意，该组件中由于使用了tip2插件，不能很好和vue兼容，所以，使用了jquery操作底层dom -->
<!-- 该组件主要完成的功能是，点击便签管理的+号，显示便签添加的tip框，然后，完成添加便签功能，
同时将数据放到vuex qrlabelStore中保管 -->
<div id="addlabelContent">
  <div class="dialog-inner-content name-container el-input el-input--small">
    <input class="label-name el-input__inner" placeholder="标签名称" maxlength="25" size="small"/>
  </div>
  <div class="dialog-inner-content label-colors-container">
    <span class="label-color label-color-1 " data-color-id="1"></span>
    <span class="label-color label-color-2 " data-color-id="2"></span>
    <span class="label-color label-color-3 " data-color-id="3"></span>
    <span class="label-color label-color-4 " data-color-id="4"></span>
    <span class="label-color label-color-5 " data-color-id="5"></span>
    <span class="label-color label-color-6 " data-color-id="6"></span>
    <span class="label-color label-color-7 " data-color-id="7"></span>
    <span class="label-color label-color-8 last-in-row " data-color-id="8"></span><br>
    <span class="label-color label-color-9 " data-color-id="9"></span>
    <span class="label-color label-color-10 " data-color-id="10"></span>
    <span class="label-color label-color-11 " data-color-id="11"></span>
    <span class="label-color label-color-12 " data-color-id="12"></span>
    <span class="label-color label-color-13 " data-color-id="13"></span>
    <span class="label-color label-color-14 " data-color-id="14"></span>
    <span class="label-color label-color-15 " data-color-id="15"></span>
    <span class="label-color label-color-16 last-in-row " data-color-id="16"></span><br>
  </div>
  <div class="dialog-footer">
    <el-button size="small" class="cancel-label">取消</el-button>
    <el-button size="small" type="primary" class="save-label" :disabled='true'>保存</el-button>
  </div>
</div>
</template>

<script type="text/javascript">
import $ from 'jquery'
import '@pp/qtip/jquery.qtip.min.css'
import '@pp/qtip/jquery.qtip.min.js'
export default {
  name: 'addLabelDialog',
  props: ['triggerTipSelector'],
  mounted () {
    const vm = this
    // 为添加标签的+号按钮添加tip动作
    $(this.triggerTipSelector).qtip({
      id: 'addLabelTip',
      show: 'click',  // 点击时显示
      hide: 'unfocus', // 失去焦点时隐藏
      position: {
        my: 'top center',
        at: 'bottom center'
      },
      style: {
        classes: 'qtip-bootstrap' // 风格
      },
      content: {
        title: '新建标签',
        text: $('#addlabelContent').html(),
        button: true
      },
      events: {
        render: function (event, api) { // 渲染时绑定
          let tipId = '#qtip-' + api.get('id')
          // 颜色选中
          $(tipId + ' .label-color').on('click', function () {
            $(tipId + ' .label-color').removeClass('label-color-selected')
            $(this).addClass('label-color-selected')
          })
          // 取消显示
          $('.cancel-label').on('click', function () {
            api.hide()
          })
          // 输入便签名称
          $('.label-name').on('input', function () {
            if ($(this).val() !== '') {
              $('.save-label').removeAttr('disabled')
              $('.save-label').removeClass('is-disabled')
            } else {
              $('.save-label').attr('disabled', 'true')
              $('.save-label').addClass('is-disabled')
            }
          })
          // 保存便签
          $('.save-label').on('click', function () {
            // 添加便签
            let name = $(tipId + ' input.label-name').val().trim()
            let color = $(tipId + ' .label-color.label-color-selected').css('background-color')
            $.ajax({
              url: '/v1/user/qrlabels',
              type: 'POST',
              dataType: 'json',
              data: {
                name: name,
                color: color
              },
              success: function (data) {
                if (data.code === 200) {
                  // 将添加成功的便签添加的vuex qrlabelStore中
                  vm.$store.dispatch('addOneQrlabel', data.data)
                } else {
                  vm.$message.warning('添加标签错误，请稍后重试')
                }
              },
              error: function () {
                vm.$message.warning('异常，请稍后重试')
              }
            })
            api.hide()
          })
        }, // end render
        show: function (event, api) {
          let tipId = '#qtip-' + api.get('id')
          // 将便签放到input框中，并初始化button
          $(this).find('.label-name').val('')
          $(tipId + ' .save-label').attr('disabled', 'true')
          $(tipId + ' .save-label').addClass('is-disabled')
          // 随机一个色彩
          let arr = $(tipId + ' .label-color')
          arr.removeClass('label-color-selected')
          arr.eq(Math.floor(Math.random() * arr.length)).addClass('label-color-selected')
        } // end show
      }
    })
  } // end mounted
}
</script>

<style scoped>
#addlabelContent {
  display: none;
}
#save_qrname:HOVER {
  color: #000;
  cursor: pointer;
}
.dialog-footer {
  position: relative;
  padding: 8px 8px;
  background: #f7f7f7;
  border-top: 1px solid #ddd;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  text-align: right;
  display: block;
}
.name-container {
  margin-bottom: 5px;
}
.label-name {
  width: 154px;
  margin-bottom: 0;
  font-size: 12px;
}
.dialog-inner-content {
    padding: 5px 9px;
}
.label-colors-container {
  border-top: 1px solid #ddd;
  padding-top: 10px;
}
.label-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #CCC !important;
  margin-right: 5px;
  border-radius: 2px;
  cursor: pointer;
}
.label-color:hover {
  border: 1px solid #000 !important;
  box-shadow:0px 0px 2px #f00;
}
.label-color-selected {
  border: 1px solid #fff !important;
  box-shadow: 0 0 4px #000;
  cursor: default;
}
.label-color-1 {
  border-color: #da1d00;
  background: #da1d00
}
.label-color-2 {
  border-color: #e9a449;
  background: #e9a449
}
.label-color-3 {
  border-color: #f5cb43;
  background: #f5cb43
}
.label-color-4 {
  border-color: #7ab45f;
  background: #7ab45f
}
.label-color-5 {
  border-color: #54949e;
  background: #54949e
}
.label-color-6 {
  border-color: #4b97d1;
  background: #4b97d1
}
.label-color-7 {
  border-color: #7b65b7;
  background: #7b65b7
}
.label-color-8 {
  border-color: #b5658c;
  background: #b5658c
}
.label-color-9 {
  border-color: #e67f7a;
  background: #e67f7a
}
.label-color-10 {
  border-color: #fbbe7b;
  background: #fbbe7b
}
.label-color-11 {
  border-color: #fce07c;
  background: #fce07c
}
.label-color-12 {
  border-color: #a3cd8d;
  background: #a3cd8d
}
.label-color-13 {
  border-color: #86b5bb;
  background: #86b5bb
}
.label-color-14 {
  border-color: #7db7e5;
  background: #7db7e5
}
.label-color-15 {
  border-color: #a091d2;
  background: #a091d2
}
.label-color-16 {
  border-color: #cd92b0;
  background: #cd92b0
}
</style>
